import React from "react";
import WeatherIcons from "react-weathericons";

import { Icon } from "antd";

// Composant de météo.
// Display correctement les informations qui lui sont passées.
const Weather = ({ weatherData }) => {
  if (!weatherData || weatherData === undefined) {
    return (
      <div className="weather-widget">
        <Icon type="loading" />
      </div>
    );
  }

  if (weatherData.error) {
    return (
      <div className="weather-widget" style={{ flexDirection: "column" }}>
        <p style={{ textAlign: "center", fontWeight: "700" }}>
          La météo n'est présentement pas disponible. Vous pouvez noter les informations sur les
          conditions météorologiques dans le champs "Prévu aujourd'hui"
        </p>
        <pre style={{ marginTop: "1em", color: "#ff1122", fontWeight: "bold" }}>
          {weatherData.error.message}
        </pre>
      </div>
    );
  }

  const formatStr = (str) => String(str).replace(".", ",");

  return (
    <div className="weather-widget">
      <div className="left-block">
        {weatherData.icon && <WeatherIcons name={weatherData.icon} />}
        <p>
          <label>Vents :</label>
          <b>{formatStr(weatherData.windSpeed)} km/h</b>
        </p>
        <p>
          <label>Raffales :</label>
          <b>{formatStr(weatherData.windGust)} km/h</b>
        </p>
      </div>

      <div className="right-block">
        <small>{weatherData.summary}</small>
        <p>
          <label>Max :</label>
          <b>{formatStr(weatherData.temperatureHigh)} °C</b>
        </p>
        <p>
          <label>Min :</label>
          <b>{formatStr(weatherData.temperatureLow)} °C</b>
        </p>
        <p>
          <label>PDP :</label>
          <b>{parseInt(weatherData.precipProbability * 100)} %</b>
        </p>
      </div>
    </div>
  );
};

export default Weather;
